import { ThemeColorCategory } from "../../../resources/modelTypes";

export enum EditDesignSidebarViews {
  Design = "design",
  Fonts = "fonts",
  Colors = "colors",
  Dividers = "dividers",
}

export const themeExtractorFontRules = [
  "fontFamily",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "letterSpacing",
  "textTransform",
];

export enum previewElementIds {
  yourNames = "yourNames",
  pageContent = "pageContent",
  navigation = "navigation",
  eventDate = "eventDate",
  welcome = "welcome",
  pageDividers = "pageDividers",
}

export const ThemeColorCategoryNavElements: Record<ThemeColorCategory, string> =
  {
    [ThemeColorCategory.background]: previewElementIds.yourNames,
    [ThemeColorCategory.text]: previewElementIds.welcome,
    [ThemeColorCategory.secondaryBackground]: previewElementIds.navigation,
    [ThemeColorCategory.secondaryText]: previewElementIds.pageContent,
    [ThemeColorCategory.linkAndButtonText]: previewElementIds.pageContent,
  } as const;

export const primaryWeddingTypographyScopes = [
  {
    dekuraGroup: "required",
    dekuraIdentifier: "LargeHeadline",
    elementId: previewElementIds.yourNames, // Used for Design Preview scrolling
    sectionTitle: "Names",
  },
  {
    dekuraGroup: "required",
    dekuraIdentifier: "MediumHeadline",
    elementId: previewElementIds.pageContent,
    sectionTitle: "Headings",
  },
  {
    dekuraGroup: "required",
    dekuraIdentifier: "Text",
    elementId: previewElementIds.pageContent,
    sectionTitle: "Body",
  },
  {
    dekuraGroup: "header",
    dekuraIdentifier: "Navbar",
    elementId: previewElementIds.navigation,
    sectionTitle: "Navigation",
  },
  {
    dekuraGroup: "required",
    dekuraIdentifier: "SmallHeadline",
    elementId: previewElementIds.pageContent,
    sectionTitle: "Subheadings",
  },
  {
    dekuraGroup: "required",
    dekuraIdentifier: "TinyHeadline",
    elementId: previewElementIds.pageContent,
    sectionTitle: "Subtitles",
  },
  {
    dekuraGroup: "header",
    dekuraIdentifier: "EventDateHeading", // Yes this identifier is weird, but changing it would be a mess
    elementId: previewElementIds.eventDate,
    sectionTitle: "Wedding Date Heading",
  },
  {
    dekuraGroup: "header",
    dekuraIdentifier: "EventDate",
    elementId: previewElementIds.eventDate,
    sectionTitle: "Event Date Heading",
  },
  {
    dekuraGroup: "header",
    dekuraIdentifier: "IntroMediumHeadline",
    elementId: previewElementIds.welcome,
    sectionTitle: "Welcome Title",
  },
];

export const homeFontScopes = ["Navbar", "LargeHeadline"];

export const introFontScopes = [
  "IntroMediumHeadline",
  "EventDate",
  "EventDateHeading",
];

export const primaryOnlineInvitationTypographyScopes = [
  {
    dekuraGroup: "required",
    dekuraIdentifier: "LargeHeadline",
    elementId: previewElementIds.yourNames,
    sectionTitle: "Event Type",
  },
  {
    dekuraGroup: "required",
    dekuraIdentifier: "MediumHeadline",
    elementId: previewElementIds.pageContent,
    sectionTitle: "Section Headings",
  },
  {
    dekuraGroup: "required",
    dekuraIdentifier: "Text",
    elementId: previewElementIds.pageContent,
    sectionTitle: "Body",
  },
];

type CustomColor = {
  color: string;
  value: string;
};

// Raw hex values of custom colors
const hexCodes: string[] = [
  "#C89F97",
  "#dfc2b8",
  "#ce6856",
  "#aa412e",
  "#af7760",
  "#68311f",
  "#c8bcb7",
  "#e4d6d1",
  "#f6e7d8",
  "#fbf6f1",
  "#535353",
  "#7D7773",
  "#968F8B",
  "#7A7D81",
  "#9C9EA0",
  "#CACAC8",
  "#DCD7D2",
  "#435060",
  "#1f4472",
  "#235BA8",
  "#A9C8F4",
  "#65a1ce",
  "#7395b4",
  "#91bacc",
  "#B4C7D3",
  "#D2E3EF",
  "#B2CCC0",
  "#4C878D",
  "#0e4e47",
  "#6AC2B2",
  "#6ECD9C",
  "#d2e7dc",
  "#BAD29E",
  "#cee1b5",
  "#88AE97",
  "#4B7C63",
  "#18975E",
  "#818C61",
  "#b5c097",
  "#DAC958",
  "#d9e497",
  "#485956",
  "#ffe0ca",
  "#ffc8b6",
  "#FF7865",
  "#ff9600",
  "#E16740",
  "#F05136",
  "#E74536",
  "#CB4F53",
  "#831717",
  "#E45C96",
  "#FFA4CC",
  "#f6dbf1",
  "#C9A0B8",
  "#AA839A",
  "#6E445A",
  "#5a1130",
  "#68527C",
  "#8E7DD2",
  "#A295BA",
  "#F4C3CB",
  "#FAD7DA",
  "#E7BBB4",
  "#FCCF61",
  "#E2A855",
  "#E8D98B",
  "#fff0c5",
];

export const customColors: CustomColor[] = hexCodes.map((hex) => ({
  color: hex,
  value: hex,
}));

export const ourStoryPlaceholder =
  "Body Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.";

export enum PreviewModes {
  design = "design",
  site = "site",
}

export enum PageDisplayModes {
  multiPage = "multi_page",
  singlePage = "single_page",
}

export const OI_UPLOAD_YOUR_OWN_IMAGE_SKUS = new Set();
